import React from "react";
import { Label } from "../../../../library/label";
import Text from "../../../../library/text";

import "./style.scss";

const Index = () => {
  return (
    <div className="new-list-right-info-container">
      <Label version={1} weight="bold">
        Informasjon
      </Label>
      <Text>
        Hver liste du lager kan ikke være på mer enn{" "}
        <span className="important">10 000</span> foretak om gangen, dersom du
        ønsker en lenger liste kan du opprette flere ulike lister. Live
        statistikk ser du nedenfor.
      </Text>
    </div>
  );
};

export default Index;
